"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextPrevDaysChangeEventResult = exports.SlotEventResult = exports.DayEventResult = exports.CalReloadedEventResult = exports.CalReloadingEventResult = void 0;
class BaseEventResult {
    constructor() {
        this.hasError = false;
        this.error = {
            message: ''
        };
    }
}
class CalReloadingEventResult extends BaseEventResult {
    constructor() {
        super();
    }
}
exports.CalReloadingEventResult = CalReloadingEventResult;
class CalReloadedEventResult extends BaseEventResult {
    constructor() {
        super();
    }
}
exports.CalReloadedEventResult = CalReloadedEventResult;
class DayEventResult extends BaseEventResult {
    constructor(resultParams) {
        super();
        this.dateId = resultParams.dateId;
        this.experience = resultParams.experience;
        this.weekIndex = resultParams.weekIndex;
        this.monthIndex = resultParams.monthIndex;
    }
}
exports.DayEventResult = DayEventResult;
class SlotEventResult extends BaseEventResult {
    constructor(resultParams) {
        super();
        this.dateId = resultParams.dateId;
        this.slotId = resultParams.slotId;
        this.isActive = resultParams.isActive;
    }
}
exports.SlotEventResult = SlotEventResult;
class NextPrevDaysChangeEventResult extends BaseEventResult {
    constructor(resultParams) {
        super();
        this.windowStartDateId = resultParams.windowStartDateId;
        this.experience = resultParams.experience;
        this.startIndex = resultParams.startIndex;
        this.endIndex = resultParams.endIndex;
        this.direction = resultParams.direction;
    }
}
exports.NextPrevDaysChangeEventResult = NextPrevDaysChangeEventResult;
class CalendarEventResultModel {
    constructor() {
        this.CalReloadingEventResult = () => {
            return new CalReloadingEventResult();
        };
        this.CalReloadedEventResult = () => {
            return new CalReloadedEventResult();
        };
        this.DayEventResult = (resultParams) => {
            return new DayEventResult(resultParams);
        };
        this.SlotEventResult = (resultParams) => {
            return new SlotEventResult(resultParams);
        };
        this.NextPrevDaysChangeEventResult = (resultParams) => {
            return new NextPrevDaysChangeEventResult(resultParams);
        };
    }
}
exports.default = CalendarEventResultModel;
